export class DataVerifyApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDriveReportPreview({ companyId, loanId }) {
    return this.#http.get(
      `/api/companies/${companyId}/loans/${loanId}/data-verify/drive-report/preview`,
    );
  }
}
